<template>
  <Popover ref="popoverRoot" v-slot="{ open, close }" as="template">
    <div
      class="inline-flex overflow-hidden rounded-md border"
      :class="open ? 'border-primary-400 dark:border-primary-500' : ''"
    >
      <Float
        :offset="10"
        portal
        :auto-placement="{
          autoAlignment: true,
          allowedPlacements: ['bottom-end', 'top-end']
        }"
      >
        <PopoverButton
          ref="popoverButton"
          class="group inline-flex items-center justify-between gap-1 px-3 py-2 font-medium hover:bg-gray-50 dark:hover:bg-slate-600"
        >
          <FontAwesomeIcon
            v-if="isLoading"
            :icon="['fal', 'spinner-third']"
            class="animate-spin"
          />
          <FontAwesomeIcon v-else :icon="['fal', 'filter']" />
          <span class="capitalize-first text-xs font-medium">
            {{ $t('global.filter') }}
          </span>
          <span
            v-if="count && count > 0"
            class="bg-primary-500 -my-1 inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium text-white"
          >
            {{ count }}
          </span>
          <FontAwesomeIcon
            class="group-hover:text-opacity-80 h-4 transition duration-150 ease-in-out"
            :class="open ? '' : 'text-opacity-70'"
            :icon="['fas', 'caret-down']"
          />
        </PopoverButton>
        <PopoverPanel class="popover-panel w-screen max-w-sm">
          <div class="flex flex-col">
            <div class="flex flex-row items-center gap-2 px-3 py-2">
              <h1 class="flex-1 text-xl font-medium capitalize">
                {{ $t('global.advanced_filters') }}
              </h1>
            </div>
            <div>
              <slot name="filter-content" :close="close" />
            </div>
          </div>
        </PopoverPanel>
      </Float>
      <button
        v-if="isDirty"
        class="inline-flex items-center border-l px-2 text-gray-400 transition hover:bg-red-50 hover:text-red-500 dark:hover:bg-red-900/20"
        @click="$emit('clear')"
      >
        <FontAwesomeIcon :icon="['fal', 'times']" class="h-3 w-3" />
      </button>
    </div>
  </Popover>
</template>
<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Float } from '@headlessui-float/vue'

export default {
  name: 'FilterContainerComponent',
  components: { Float, FontAwesomeIcon, PopoverPanel, Popover, PopoverButton },
  props: {
    count: {
      type: Number,
      default: 0
    },
    isDirty: {
      type: Boolean,
      default: false
    }
  },
  emits: ['clear'],
  data() {
    return {
      isLoading: false
    }
  },
  computed: {},
  methods: {
    openPopover() {
      // Headless UI exposes $el as a Vue Ref (not a raw HTMLElement) — unwrap with .value
      const elOrRef = this.$refs.popoverButton?.$el
      const el = elOrRef?.value ?? elOrRef
      if (el instanceof HTMLElement) {
        el.click()
      }
    }
  }
}
</script>